import React, { type InputHTMLAttributes, type Ref, useMemo } from "react";
import { Field, type Validator } from "redux-form";
import type IFormInputs from "./IFormInputs";
import {
  type InputRef,
  InputRenderer,
} from "src/shared/forms/formrenderers/InputRenderer";
import { combineReduxFormValidationRules } from "src/shared/forms/validations/combineReduxFormValidationRules";
import { length as Length } from "src/shared/forms/validations/Length";
import NoTrailingSpace from "src/shared/forms/validations/NoTrailingSpace";
import Regex from "src/shared/forms/validations/Regex";
import { required as Required } from "src/shared/forms/validations/Required";

export interface ITextInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  isRequired?: boolean;
  regex?: RegExp;
  isNoTrailingSpace?: boolean;
  validate?: Validator | Validator[];
  rows?: number;
  inputRef?: Ref<InputRef>;
}

export const TextInput = ({
  inputID,
  label = null,
  isRequired = true,
  minLength,
  maxLength,
  isNoTrailingSpace,
  regex,
  type,
  validationDisabled,
  validate,
  ...rest
}: ITextInputProps) => {
  const validations = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return combineReduxFormValidationRules(
      isRequired && Required,
      Boolean(minLength || maxLength) && Length(minLength, maxLength),
      isNoTrailingSpace && NoTrailingSpace,
      regex && Regex(regex),
      validate,
    );
  }, [
    validationDisabled,
    isRequired,
    minLength,
    maxLength,
    isNoTrailingSpace,
    regex,
    validate,
  ]);

  return (
    <Field
      name={inputID}
      label={label}
      component={InputRenderer}
      type={type || "text"}
      {...rest}
      validate={validations}
    />
  );
};

/**
 * @deprecated
 */
export default TextInput;
